import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ITagInputItem } from 'src/app/common/components/tags-input.component/tags-input.component';
import { APCIS } from 'src/app/common/data/apcis';
import countries from 'src/app/common/data/countries';
import { DoctorPatient } from 'src/app/entities/doctor-patient.entity/doctor-patient';
import { EUserGender } from 'src/app/entities/user.entity';
import { AssistancePatientsService } from 'src/app/services/assistance-appointments.service/assistance-patients.service/assistance-patients.service';

@Component({
  selector: 'app-create-patient-assistance',
  templateUrl: './create-patient-assistance.component.html',
  styleUrls: ['./create-patient-assistance.component.css']
})
export class CreatePatientAssistanceComponent implements OnInit {

patientProfileForm!: FormGroup;
  patientAssuranceForm!: FormGroup;
  patientAccompanistForm!: FormGroup;
  imageUrl: string = '';
  isLoading: boolean = false;
  isSubmitted: boolean = false;
  assurance: string = '';
  public imageFile!: File;
  @Output() completed: EventEmitter<DoctorPatient> = new EventEmitter();
  @Input() isFilter: boolean = false;
  @Output() isFilterChange:EventEmitter<boolean>= new EventEmitter()
  file: any;
  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private assistancePatientsService: AssistancePatientsService,
    private router: Router
  ) { }

  get countries(): Array<any> {
    return countries;
  }  get PhonePrependHtml(): string { return `<span>${this.currentCountry?.dialCode || '+216'}</span>` }
  get currentCountry(): any { return this.patientProfileForm.controls.country.value }
  hasAssurance: boolean = true;
  hasAccompanist: boolean = true;

  get currentDate(): Date {
    return new Date();
  }

  get apicsSource(): Array<ITagInputItem> {
    return APCIS.map(e => {
      return {
        id: String(e.index),
        value: e.index,
        text: `${e.index + 1}.${e.value}`,
      }
    });
  }
  ngOnInit(): void {
    window.scrollBy(100, 0);

    this.patientProfileForm = this.formBuilder.group({
      ref: [''],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      country: [{ name: "Tunisie", dialCode: "+216", isoCode: "TN", flag: "https://cdn.kcak11.com/CountryFlags/countries/tn.svg" }, [Validators.required]],
      address: [''],
      email: [null],
      birthDate: [null, [Validators.required]],
      gender: [EUserGender.HOMME],
      mobilePhone1: [""],
      socialCivility: [0],
      sanguineGroup: [0],
      cnamCode: [''],
      cnamAssociation: [0],
      apcis: [[]],
      patientNote:[''],
      government: ['']
    });
    this.patientAssuranceForm = this.formBuilder.group({
      //  assuranceType: ['STAR', [Validators.required]],
      //  assuranceName: ['', [Validators.required]],
      //  assuranceReference: ['', [Validators.required]],
      assuranceType: ['',],
      assuranceName: [''],
      assuranceReference: [''],
    });
    this.patientAccompanistForm = this.formBuilder.group({
      accompanistUserName: [''],
    })
  }

  get isValid(): boolean {
    return this.patientProfileForm.valid && (this.hasAccompanist ? this.patientAccompanistForm.valid : true) && (this.hasAssurance ? this.patientAssuranceForm.valid : true);
  }

  onFileSelect(event: any) {
    let reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (event) =>
      (this.imageUrl = event.target?.result?.toString()!);
    this.imageFile = event.target.files[0];
  }
  get f(): any { return this.patientProfileForm.controls; }

  private emptyToNull(value: any): any {
    return value === '' || value === undefined ? null : value;
  }

  private normalizeZeroValue(value: any, length: number): any {
    if (!value) return null;
    return String(value).padStart(length, '0');
  }


  get patientModel(): any {
    var patientModal: Object = {
      ref: this.emptyToNull(this.patientProfileForm.controls.ref.value),
      firstName: this.patientProfileForm.controls.firstName.value,
      lastName: this.patientProfileForm.controls.lastName.value,
      email: this.patientProfileForm.controls.email.value
        ? this.patientProfileForm.controls.email.value.toLocaleLowerCase()
        : null,
      mobilePhone1: this.patientProfileForm.controls.mobilePhone1.value,
      mobilePhone2: this.patientProfileForm.controls.mobilePhone2.value,
      childRank: this.patientProfileForm.controls.childRank.value,

      affiliationCode: this.patientProfileForm.controls.affiliationCode.value,

      gender: this.patientProfileForm.controls.gender.value,
      sanguineGroup: this.patientProfileForm.controls.sanguineGroup.value,
      birthDate: new Date (this.patientProfileForm.controls.birthDate.value).getTime(),
      socialCivility: this.patientProfileForm.controls.socialCivility.value,
      country: this.patientProfileForm.controls.country.value.name,
      address: this.patientProfileForm.controls.address.value,
      government: this.patientProfileForm.controls.government.value,
cnamCode: this.normalizeZeroValue(
  this.patientProfileForm.controls.cnamCode.value,
  10
),

familyDoctorMatricule: this.normalizeZeroValue(
  this.patientProfileForm.controls.familyDoctorMatricule.value,
  12
),      cnamAssociation: this.patientProfileForm.controls.cnamAssociation.value,
      cnamexpirationDate: this.patientProfileForm.controls.cnamexpirationDate.value? new Date(this.patientProfileForm.controls.cnamexpirationDate.value).getTime() : null,
      note: this.patientProfileForm.controls.note.value,
      familyDoctorName: this.patientProfileForm.controls.familyDoctorName.value,
     
      tierPayant: this.patientProfileForm.controls.tierPayant.value,
      pec: this.patientProfileForm.controls.pec.value,
      evax: this.patientProfileForm.controls.evax.value,

      apcis: (
        this.patientProfileForm.controls.apcis.value as Array<ITagInputItem>
      ).map((e) => e.id),
    };

    if (this.hasAssurance) {
      patientModal = {
        assuranceType: this.patientAssuranceForm.controls.assuranceType.value,
        assuranceName: this.patientAssuranceForm.controls.assuranceName.value,
        assuranceReference:
          this.patientAssuranceForm.controls.assuranceReference.value,
        assuranceOrganization:
          this.patientAssuranceForm.controls.assuranceType.value,
        ...patientModal,
      };
    }

    return patientModal;
  }

  onSubmit(): void {
    if (this.patientAssuranceForm.controls.assuranceType.value != 'Autre') this.patientAssuranceForm.controls.assuranceName.setValue(this.patientAssuranceForm.controls.assuranceType.value);
    this.isSubmitted = true;
    if (!this.isValid) return;
    const formData = new FormData();
    formData.append('photo', this.imageFile);
    formData.append('patient', JSON.stringify(this.patientModel));
    this.isLoading = true;
    this.assistancePatientsService.add(formData, !this.patientAccompanistForm.controls.accompanistUserName.errors && String(this.patientAccompanistForm.controls.accompanistUserName.value).length > 0 ? this.patientAccompanistForm.controls.accompanistUserName.value : null).subscribe(
      (res) => {
        this.completed.emit(DoctorPatient.fromResponse(res))
        this.toastrService.success('Patient créé avec succès');
        this.isFilter = false
        this.isFilterChange.emit(this.isFilter);        this.isLoading = false;
      },
     (error) => {
  this.isLoading = false;

  const err = typeof error === 'function' ? error() : error;
  const body = err?.error || error;


   if (err?.status === 409) {
  const patient = body?.data;

  if (patient) {
    // Toast avec les infos du patient existant
    const birthDate = patient.birthDate
      ? new Date(patient.birthDate).toLocaleDateString('fr-FR')
      : '';

    this.toastrService.warning(
      `Un patient avec ces informations existe déjà :<br>
       <b>Prénom :</b> ${patient.firstName}<br>
       <b>Nom :</b> ${patient.lastName}<br>
       <b>Date de naissance :</b> ${birthDate}`,
      'Patient déjà existant',
      {
        enableHtml: true,
        timeOut: 6000,
        positionClass: 'toast-top-center',
      }
    );
  } else {
    // Cas de la référence dupliquée (pas de data.patient renvoyée)
    this.toastrService.warning(
      body?.message || 'Un patient avec la même référence existe déjà pour ce médecin',
      'Patient déjà existant',
      {
        enableHtml: true,
        timeOut: 6000,
        positionClass: 'toast-top-center',
      }
    );
  }

}  else if (body?.kind === 'EntityExistsException') {
    // Patient déjà existant via email
    const existingUser = body?.data;
    const email = existingUser?.email || existingUser?.username || '';

    this.toastrService.warning(
      `Ce patient existe déjà avec l'email : <b>${email}</b>`,
      'Patient déjà existant',
      {
        enableHtml: true,
        timeOut: 6000,
        positionClass: 'toast-top-center',
      }
    );

  } else if (body?.kind === 'EntityNotFoundException') {
    this.patientAccompanistForm.controls.accompanistUserName.setErrors({
      notFound: true,
    });

  } else {
    this.toastrService.error(
      body?.message || 'Problème de Création de patient !',
      'Erreur'
    );
  }
}
    );
  }


}


